/**
 * 数据库、社区左侧菜单
*/
const Novelty = {
    namespaced: true,
    state: {
        list: [
            {id: 1, identifier: 'TSG ZF001-2001', name: '安全阀安全技术监察规程1', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'},
            {id: 2, identifier: 'TSG ZF001-2002', name: '安全阀安全技术监察规程2', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'},
            {id: 3, identifier: 'TSG ZF001-2003', name: '安全阀安全技术监察规程3', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'},
            {id: 4, identifier: 'TSG ZF001-2004', name: '安全阀安全技术监察规程4', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'},
            {id: 5, identifier: 'TSG ZF001-2005', name: '安全阀安全技术监察规程5', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'},
            {id: 6, identifier: 'TSG ZF001-2006', name: '安全阀安全技术监察规程6', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'},
            {id: 7, identifier: 'TSG ZF001-2007', name: '安全阀安全技术监察规程7', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'},
            {id: 8, identifier: 'TSG ZF001-2008', name: '安全阀安全技术监察规程8', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'},
            {id: 9, identifier: 'TSG ZF001-2009', name: '安全阀安全技术监察规程9', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'},
            {id: 10, identifier: 'TSG ZF001-2010', name: '安全阀安全技术监察规程10', status: '【电子版】', releaseDate: '2025-10-04', executeDate: '2025-10-04'}
        ]
    },

    getters: {
    },

    actions: {
        checkAll (context, checked) {
            context.commit('checkAll', checked)
        },

        // 删除记录
        rmItem (context, index) {
            context.commit('rmItem', index)
        },

        // 通过ID删除记录
        rmByid (context, ids) {
            context.commit('rmByid', ids)
        },

        // 添加一条记录
        addItem (context, info) {
            context.commit('addItem', info)
        }
    },

    mutations: {
        checkAll (state, checked) {
            state.list.forEach(item => {
                item.checked = checked
            })
        },

        rmItem (state, index) {
            state.list.splice(index, 1)
        },

        // 批量删除
        rmByid (state, ids) {
            state.list = state.list.filter(info => !ids.includes(info.id)) 
        },

        // 添加元素
        addItem (state, info) {
            state.list.unshift(info)
        }
    }
}

export default Novelty